import React from "react";
import { Grid, Typography } from "@mui/material";
import { VehicleTextField } from "../VehicleFormFields";

const CommentsTab: React.FC = () => {
  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Add any additional notes or special instructions for this vehicle.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <VehicleTextField 
            name="comments" 
            label="Comments" 
            multiline 
            rows={4}
            placeholder="Enter any additional comments about this vehicle..."
            tooltip="Free text field for any additional information"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CommentsTab;
